import { Button } from '@lmig/lmds-react-button';
import { useUserData } from 'Foundation/User/UserContext';
import { useState } from 'react';
import AgencyCacheTool from 'Feature/AgencyTools/AgencyCacheTool';

export function EmployeeTools() {
  const { userData } = useUserData();
  const [clearLocalSessionStatus, setClearLocalSessionStatus] = useState<boolean | undefined>(undefined);

  function onClearSessionCache() {
    sessionStorage.clear();
    setClearLocalSessionStatus(true);
  }

  return (
    <>
      {!userData?.isAgent() && (
        <div>
          <div className="container">
            <div className="row" style={{ marginTop: '15px' }}>
              Clear local browser cache:
              <Button
                size="large"
                variant="primary"
                onClick={onClearSessionCache}
                className="btnSubmit"
                style={{ width: '250px', marginLeft: '16px' }}
              >
                Clear Session Cache
              </Button>
              {clearLocalSessionStatus !== undefined && (
                <>
                  {clearLocalSessionStatus ? (
                    <div className="alert alert-success" role="alert" style={{ marginLeft: '15px' }}>
                      Local session cache clear successful
                    </div>
                  ) : (
                    <div className="alert alert-danger" role="alert" style={{ marginLeft: '15px' }}>
                      Local session cache clear failed
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="row" style={{ marginTop: '15px' }}>
              <AgencyCacheTool></AgencyCacheTool>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
